function n(r) {
  return (e) => {
    if (e.keyCode === 13)
      return r(e);
  };
}
function t(r) {
  return (e) => {
    if (e.keyCode === 9)
      return r(e);
  };
}
function o(r) {
  return (e) => {
    if (e.button === 0)
      return r(e);
  };
}
const u = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  onKeyboardEnter: n,
  onMouseLeftClick: o,
  onTabClick: t
}, Symbol.toStringTag, { value: "Module" }));
export {
  n as a,
  t as b,
  u as e,
  o
};
